import React from 'react';
import styled from 'styled-components';
import { useQuote } from '../../contexts/QuoteContext';

const BadgeContainer = styled.span<{ count: number }>`
  display: ${({ count }) => count > 0 ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -8px;
  right: -8px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background-color: ${({ theme }) => theme.colors.error};
  color: ${({ theme }) => theme.colors.light};
  font-size: 0.75rem;
  font-weight: bold;
`;

const QuoteBadge: React.FC = () => {
  const { quoteItems } = useQuote();
  
  return (
    <BadgeContainer count={quoteItems.length}>
      {quoteItems.length}
    </BadgeContainer>
  );
};

export default QuoteBadge; 